import { gate } from 'hub-http/gates';
import { userInfoSync } from 'hub-http/userInfo';

export const SALES_DOCUMENTS_CHIRP_GATE = gate(
  'BuyerExperience:SalesDocumentsCHIRPMigration'
);

export const isUngatedForDocumentsCHIRP = (): boolean => {
  try {
    return userInfoSync().gates.includes(SALES_DOCUMENTS_CHIRP_GATE);
  } catch {
    return false;
  }
};
